import { useEffect, useState } from "react";

interface CommerceDataState<T> {
    data: T | null;
    loading: boolean;
    error: Error | null;
}

/**
 * Thin wrapper around a `commerceRepository` call: tracks loading/error state
 * and re-fetches whenever `deps` change. Works the same whether the fetcher
 * hits the mock repository or, later, the Shopify Storefront API.
 */
export function useCommerceData<T>(fetcher: () => Promise<T>, deps: React.DependencyList = []): CommerceDataState<T> {
    const [state, setState] = useState<CommerceDataState<T>>({ data: null, loading: true, error: null });

    useEffect(() => {
        let cancelled = false;
        setState((prev) => ({ ...prev, loading: true, error: null }));

        fetcher()
            .then((data) => {
                if (!cancelled) setState({ data, loading: false, error: null });
            })
            .catch((error) => {
                if (!cancelled) setState({ data: null, loading: false, error });
            });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return state;
}
